import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsToDottedLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.7188 6.28516L7.65625 3.44141C7.38281 3.19531 6.97266 3.19531 6.72656 3.46875C6.48047 3.74219 6.48047 4.15234 6.75391 4.39844L8.58594 6.09375H3.9375C3.55469 6.09375 3.28125 6.39453 3.28125 6.75C3.28125 7.13281 3.55469 7.40625 3.9375 7.40625H8.58594L6.75391 9.12891C6.48047 9.375 6.48047 9.78516 6.72656 10.0586C6.97266 10.332 7.38281 10.332 7.65625 10.0859L10.7188 7.24219C10.8555 7.13281 10.9375 6.94141 10.9375 6.75C10.9375 6.58594 10.8555 6.39453 10.7188 6.28516ZM7 0.1875C3.36328 0.1875 0.4375 3.14062 0.4375 6.75C0.4375 10.3867 3.36328 13.3125 7 13.3125C10.6094 13.3125 13.5625 10.3867 13.5625 6.75C13.5625 3.14062 10.6094 0.1875 7 0.1875ZM7 12C4.10156 12 1.75 9.64844 1.75 6.75C1.75 3.87891 4.10156 1.5 7 1.5C9.87109 1.5 12.25 3.87891 12.25 6.75C12.25 9.64844 9.87109 12 7 12Z",
		fill: "#651FFF"
	})]
});
const ForwardRef = forwardRef(SvgArrowsToDottedLine);
export { ForwardRef as ReactComponent };
